import type { FaireProductEntity } from "../../entity_types/product";

export const p_f3yxgc29pu: FaireProductEntity = {
  token: "p_f3yxgc29pu",
  type: "product",
  name: "Date Cola - Natural Soda (12-Pack)",
  brandToken: "b_zgjjdpnm4g",
  brandName: "Fresh Fizz Sodas",
  imageUrl:
    "https://cdn.faire.com/fastly/fe213bcef1390e62f5bc92db287f7f05a8bd03a626ef792fc7e1d2c9a2ab27ee.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5e8a303e5d1a95c9d91f256198ce4604a576c211f6c7ac20fd4386da3062b53.png",
    "https://cdn.faire.com/fastly/7d9fccb316ce612f23765a02a002795f02ddc1ac3bd555019e5c1b161ac19bd1.png",
  ],
  priceDollars: 29.1,
  description:
    "Our Date Cola is like no other colas in the market. Our spices will take you to your happy place with every sip.\n\nIngredients: Carbonated Water, Organic Lemon Juice (from concentrate), Organic Date Syrup, Organic Spices(Orange Peel, Allspices, Star Anise), Organic Vanilla Bean\n\nEach 12 oz can contain only these natural, real food ingredients and nothing else - no 'natural' flavors, extracts, preservatives, or processed sugar, and nothing artificial: 60 calories and 15g sugar per can.\n\n",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:31.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
